/**
 * รายการธนาคารจาก Configuration Service — แหล่งเดียวกับ user-classic (BankContext)
 * ใช้ในหน้า Complete สมัครสมาชิก (เลือกธนาคาร + ไอคอน)
 */
function getBaseURL(): string {
  return (import.meta.env.VITE_API_BASE_URL as string) || 'http://localhost:8081'
}

export interface BankIcon {
  _id: string
  name: string
  abbreviation: string
  bankCode: string
  imageUrl: string
  isActive?: boolean
  createdAt?: string
  updatedAt?: string
  __v?: number
}

export interface BankOption {
  value: string
  label: string
  imageUrl: string
}

/** ดึงรายการธนาคาร: tenant-content ก่อน ถ้าไม่มีใช้ global-banks */
export async function fetchAvailableBanks(tenantId: string): Promise<BankIcon[]> {
  const baseURL = getBaseURL().replace(/\/$/, '')
  const configBase = `${baseURL}/api/v1/configuration-service`
  const globalBanksUrl = `${configBase}/public/global-banks`

  if (tenantId) {
    try {
      const tenantUrl = `${configBase}/tenant-content/${tenantId}`
      const res = await fetch(tenantUrl, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      })
      if (res.ok) {
        const data = await res.json()
        if (data?.success && Array.isArray(data?.data?.bankList) && data.data.bankList.length > 0) {
          return data.data.bankList
        }
      }
    } catch (err) {
      console.warn('Failed to fetch tenant banks, falling back to global:', err)
    }
  }

  const res = await fetch(globalBanksUrl, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  })
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  const data = await res.json()
  if (!data?.success || !Array.isArray(data?.data)) throw new Error('Invalid global banks response')
  return data.data
}

/** แปลง BankIcon[] เป็น BankOption[] (เฉพาะที่ active) */
export function toBankOptions(banks: BankIcon[]): BankOption[] {
  return banks
    .filter((b) => b.isActive !== false)
    .map((b) => ({
      value: b.abbreviation,
      label: b.name,
      imageUrl: b.imageUrl || '',
    }))
}
